export const kratosMessages: Record<string, string> = {
  'You have no WebAuthn device set up.': '此账号尚未添加通行密钥或安全密钥。',
  'This account does not exist or has no security key set up.': '此账号不存在，或尚未添加通行密钥或安全密钥。',
  'Email': '邮箱',
  'Enter a valid email address.': '请输入有效的邮箱地址。',
  'Username': '用户名',
  'Name': '姓名',
  'First name': '名字',
  'Last name': '姓氏',
  'Code': '验证码',
  'Save': '保存',
  'Submit': '提交',
  'Verify': '验证',
  'Verify code': '验证验证码',
  'Resend code': '重新发送验证码',
  'Recovery code': '账号恢复码',
  'Verification code': '邮箱验证码',
  'Registration code': '注册验证码',
  'Login code': '登录验证码',
  'Authentication code': '身份验证码',
  'Backup recovery code': '备用恢复码',
  'Sign up': '注册',
  'Sign in with code': '使用验证码登录',
  'Sign up with code': '使用验证码注册',
  'Continue with code': '使用验证码继续',
  'Sign in and link': '登录并关联',
  'Login and link credential': '登录并关联凭据',
  'Sign in with {provider}': '使用 {provider} 登录',
  'Sign up with {provider}': '使用 {provider} 注册',
  'Sign in with {provider} and link credential': '使用 {provider} 登录并关联凭据',
  'Link {provider}': '关联 {provider}',
  'Unlink {provider}': '取消关联 {provider}',
  'Please confirm this action by verifying that it is you.': '请验证身份以确认此操作。',
  'Please complete the second authentication challenge.': '请完成第二步身份验证。',
  'Your changes have been saved!': '更改已保存。',
  'You successfully verified your email address.': '邮箱验证成功。',
  'A recovery link has been sent to the email address you provided. If it does not arrive, check the address and use the one you registered with.': '恢复链接已发送至你提供的邮箱。如果未收到邮件，请检查地址是否正确，并使用注册时的邮箱。',
  'A recovery code has been sent to the email address you provided. If it does not arrive, check the address and use the one you registered with.': '恢复码已发送至你提供的邮箱。如果未收到邮件，请检查地址是否正确，并使用注册时的邮箱。',
  'A verification link has been sent to the email address you provided. If it does not arrive, check the address and use the one you registered with.': '验证链接已发送至你提供的邮箱。如果未收到邮件，请检查地址是否正确，并使用注册时的邮箱。',
  'A verification code has been sent to the email address you provided. If it does not arrive, check the address and use the one you registered with.': '验证码已发送至你提供的邮箱。如果未收到邮件，请检查地址是否正确，并使用注册时的邮箱。',
  'A login code has been sent to your email address. If it does not arrive, check the address and try signing in again.': '登录验证码已发送至你的邮箱。如果未收到邮件，请检查地址并重新尝试登录。',
  'A registration code has been sent to your email address. If it does not arrive, check the address and try registering again.': '注册验证码已发送至你的邮箱。如果未收到邮件，请检查地址并重新尝试注册。',
  'Your account has been recovered. Change your password or set up another sign-in method within {minutes} minutes.': '账号已恢复。请在 {minutes} 分钟内更改密码或设置其他登录方式。',
  '{field} is required.': '请填写{field}。',
  'Use at least {min_length} characters (currently {actual_length}).': '至少需要 {min_length} 个字符（当前为 {actual_length} 个）。',
  'Use at most {max_length} characters (currently {actual_length}).': '最多允许 {max_length} 个字符（当前为 {actual_length} 个）。',
  'The value does not match the required format.': '输入内容不符合格式要求。',
  'The password cannot be used: {reason}': '无法使用该密码：{reason}',
  'The provided credentials are invalid, check for spelling mistakes in your password or username, email address, or phone number.': '登录信息不正确，请检查密码、用户名、邮箱或手机号码。',
  'An account with the same identifier (email, phone, username, ...) exists already.': '该邮箱、手机号码或用户名已被使用。',
  'The provided authentication code is invalid, please try again.': '身份验证码无效，请重试。',
  'Could not find any login identifiers. Did you forget to set them? This could also be caused by a server misconfiguration.': '未找到登录标识。请检查是否已填写；这也可能是服务配置问题。',
  'Account not active yet. Did you forget to verify your email address?': '账号尚未激活，请先验证邮箱。',
  'An account with the same identifier already exists. Sign in to your existing account to link your social profile.': '该邮箱、手机号码或用户名已被使用。请登录已有账号以关联第三方账号。',
  'The password can not be used because it is too similar to the identifier.': '密码与登录标识过于相似，请使用其他密码。',
  'The password must be at least {min_length} characters long, but got {actual_length}.': '密码至少需要 {min_length} 个字符，当前为 {actual_length} 个。',
  'The password must be at most {max_length} characters long, but got {actual_length}.': '密码最多允许 {max_length} 个字符，当前为 {actual_length} 个。',
  'The password has been found in data breaches and must no longer be used.': '该密码曾出现在数据泄露中，请使用其他密码。',
  'This account does not exist or has not setup sign in with code.': '账号不存在或尚未设置验证码登录。',
  'The provided traits do not match the traits previously associated with this flow.': '填写的账号信息与当前流程中的信息不一致。',
  'This login form has expired. Please try again.': '登录表单已过期，请重试。',
  'This registration form has expired. Please try again.': '注册表单已过期，请重试。',
  'This settings form has expired. Please try again.': '设置表单已过期，请重试。',
  'This recovery form has expired. Please try again.': '账号恢复表单已过期，请重试。',
  'This verification form has expired. Please try again.': '邮箱验证表单已过期，请重试。',
  'Could not find a strategy to log you in with. Did you fill out the form correctly?': '无法完成登录，请检查表单内容。',
  'Could not find a strategy to sign you up with. Did you fill out the form correctly?': '无法完成注册，请检查表单内容。',
  'Could not find a strategy to update your settings. Did you fill out the form correctly?': '无法更新设置，请检查表单内容。',
  'Could not find a strategy to recover your account with. Did you fill out the form correctly?': '无法恢复账号，请检查表单内容。',
  'Could not find a strategy to verify your account with. Did you fill out the form correctly?': '无法验证账号，请检查表单内容。',
  'The request was already completed successfully and can not be retried.': '此请求已成功完成，无法重复提交。',
  'The login code is invalid or has already been used. Please try again.': '登录验证码无效或已被使用，请重试。',
  'The registration code is invalid or has already been used. Please try again.': '注册验证码无效或已被使用，请重试。',
  'The recovery code is invalid or has already been used. Please try again.': '恢复码无效或已被使用，请重试。',
  'The verification code is invalid or has already been used. Please try again.': '邮箱验证码无效或已被使用，请重试。',
  'The recovery token is invalid or has already been used. Please retry the flow.': '恢复链接无效或已被使用，请重新恢复账号。',
  'The verification token is invalid or has already been used. Please retry the flow.': '验证链接无效或已被使用，请重新验证邮箱。',
  'The recovery flow reached a failure state and must be retried.': '账号恢复失败，请重试。',
  'The verification flow reached a failure state and must be retried.': '邮箱验证失败，请重试。',
  'Linked credentials do not match.': '关联的登录凭据不匹配。',
  'The address you entered does not match any known addresses in the current account.': '输入的地址与当前账号中的地址不匹配。',
}
